import type { CreditorBalanceContact, CreditorBalanceTotals } from '../query-api'
import type { SuppliersBalance, SuppliersBalanceTotals } from '../types/SuppliersBalance'
import { minorToMajor } from './moneyUtils'

export const normalizeCreditorBalanceContact = (contact: CreditorBalanceContact): SuppliersBalance => ({
  id: contact.contactId,
  auxiliaryAccountNo: contact.auxiliaryAccountNo ?? null,
  name: contact.contactName,
  balance: minorToMajor(contact.balance.value),
  lastPeriod: contact.comparisonBalance ? minorToMajor(contact.comparisonBalance.value) : 0,
  variance: contact.variance ? minorToMajor(contact.variance.value) : 0,
  variancePercentage: contact.variancePercent ?? null,
})

export const normalizeCreditorBalanceTotals = (totals: CreditorBalanceTotals): SuppliersBalanceTotals => ({
  balance: minorToMajor(totals.balance.value),
  lastPeriod: totals.comparisonBalance ? minorToMajor(totals.comparisonBalance.value) : 0,
})
